/*
export interface Request {
  // 医嘱 / 用药说明
  advice: string;
  // 预问诊小结
  consultationSummaryDTO: ConsultationSummaryDTO;
  // 诊断信息
  diagnosisVOList: DiagnosisVOList[];
  // 医生ID
  doctorId: number;
  // 医生名称
  doctorName: string;
  // 主诉
  mainComplaint: string;
  // 患者年龄
  patientAge: number;
  // 患者年龄单位，固定“岁”
  patientAgeUnit: string;
  // 患者性别，0女，1男，2未知
  patientGender: number;
  // 患者ID
  patientId: number;
  // 患者名称
  patientName: string;
  // 就诊人ID
  patientProfileId: number;
  // 问诊诊费相关
  recommendCureParamVO: RecommendCureParamVO;
  // 开方备注
  remark: string;
  // 复诊提醒基础信息
  revisitRemindInfo: RevisitRemindInfo;
  // 药品信息
  skuInfoList: SkuInfoList[];
  // 服用禁忌，服用禁忌、医嘱 两个字段合并为嘱托
  taboo: string;
  // 当前的登录用户ucId，健管的ucId
  ucDaId: number;
  [property: string]: any;
}

// 预问诊小结
export interface ConsultationSummaryDTO {
  // 预病历ID，后端传
  advanceMedicalRecordId: number;
  // 用药清单
  medicationSituation: string[];
  // 用药状态，0：未服用 1：服用中 2:疗程即将结束 3:疗程已结束
  medicationStatus: number;
  // 用药说明
  medicationSupplementDescribe: string;
  // 操作人，后端传
  operatorId: number;
  // 是否无需填写，true需要填写，false无需填写，原先BD端有一个按钮的，这一块需要看一下怎么处理。看去好像健管端都要填预问诊小结
  requiredFillIn: boolean;
  [property: string]: any;
}

export interface DiagnosisVOList {
  // 诊断类型
  diagnosisType?: number;
  // gb21诊断名称
  gb21DiagnosisName?: string;
  // 诊断ID
  id?: number;
  // 诊断名称
  name?: string;
  // 诊断备注
  remark?: string;
  [property: string]: any;
}

// 问诊诊费相关
export interface RecommendCureParamVO {
  // 问诊id，不传
  consultId: number;
  // 问诊(价格) (元)
  payAmountYuan: number;
  [property: string]: any;
}

// 复诊提醒基础信息
export interface RevisitRemindInfo {
  // 是否修改复诊日 0-未修改 1-已修改  -1-未更新版本
  modifyReserveDateFlag: number;
  // 无需复诊 原因: 1-治愈 0-其他
  noNeedRemind: number;
  // 无需复诊原因
  noNeedRemindReason: string;
  // 是否无需复诊，默认false
  notNeedReserve: boolean;
  // 复诊日期
  reserveDate: string;
  // 复诊提醒日期具体时间端: 1-上午 2-下午
  reserveDateDetail: number;
  // 复诊预约入口  1-处方 2-推送补充诊疗记录卡片 3-患者档案补充诊疗记录  4-复诊预约
  reserveEntry: number;
  // 复诊提醒类型: 1-线上问诊 2-线下就诊
  revisitType: number;
  [property: string]: any;
}

export interface SkuInfoList {
  // 药品数量
  quantity?: number;
  // 药品编码
  skuCode?: string;
  // 药品名称
  skuName?: string;
  // 药品ID
  skuId?: number;
  // 药品类型，PRODUCT(0, "商品", "P"),
  // MEDICINE(1, "西药", "M"),
  // CHINESE(2, "中药", "Z"),
  // @Deprecated AGREEMENT(3, "协定方", "X"),
  // HEALTH(4, "健康用品", "H"),
  // CHINESE_PATENT(5, "中成药", "C"),
  // PACKAGE(6, "活动套餐", "T"),
  // AGREEMENT_COMBINATION(7, "协定方(组合)", "XZ"),
  // PRESCRIPTION_RECOMMEND(8, "推荐方", "R"),
  // VIRTUAL_GOODS(9, "虚拟商品", "V"),
  // NEW_COMBINATION_PRESCRIPTION(10, "推荐方(组合方)", "TJ"),
  // VIRTUAL_COMBINATION_PRESCRIPTION(11, "虚拟推荐方(虚拟组合方)", "XN");
  // 这里只有西药、中成药、健康用品、协定方
  skuType?: number;
  [property: string]: any;
}
*/
const createDefaultState = () => ({
  doctorId: null,
  doctorName: null,
  ucDoctorId: null,
  patientId: null,
  patientName: null,
  ucPatientId: null,
  patientAge: null,
  patientAgeUnit: null,
  patientGender: null,
  patientProfileId: null,
  remark: null,
  mainComplaint: null,
  taboo: null,
  advice: null,
  consultationSummaryDTO: {
    advanceMedicalRecordId: null,
    medicationStatus: null,
    medicationSituation: null,
    medicationSupplementDescribe: null,
    operatorId: null,
    requiredFillIn: null
  },
  recommendCureParamVO: {
    payAmountYuan: null
  },
  revisitRemindInfo: {
    revisitType: null,
    reserveDate: null,
    reserveDateDetail: null,
    noNeedRemind: null,
    noNeedRemindReason: null,
    notNeedReserve: null,
    modifyReserveDateFlag: null,
    reserveEntry: null
  },
  skuInfoList: [],
  diagnosisVOList: [],
  ucDaId: null
})

const state = () => createDefaultState()

const mutations = {
  SET_PRE_MEDICAL_RECORD(state, payload) {
    Object.assign(state, payload)
  },
  UPDATE_PRE_MEDICAL_RECORD(state, payload) {
    Object.keys(payload || {}).forEach(key => {
      if (payload[key] !== undefined) state[key] = payload[key]
    })
  },
  RESET_PRE_MEDICAL_RECORD(state) {
    Object.assign(state, createDefaultState())
  }
}

const actions = {
  setPreMedicalRecord({ commit }, payload) {
    commit('SET_PRE_MEDICAL_RECORD', payload)
  },
  updatePreMedicalRecord({ commit }, payload) {
    commit('UPDATE_PRE_MEDICAL_RECORD', payload)
  },
  resetPreMedicalRecord({ commit }) {
    commit('RESET_PRE_MEDICAL_RECORD')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
